<script setup>
import { ref } from 'vue';
import { defineProps } from 'vue';
import swifLogo from '../assets/logo/swif_logo.png';

defineProps({
    navigate: {
        type: Function,
        required: true
    },
    activePage: {
        type: String,
        default: 'home'
    }
});

const isMenuOpen = ref(false);
</script>

<template>
    <header class="sticky top-0 z-50 bg-white shadow-md">
        <div class="container mx-auto px-4 py-3 flex flex-wrap justify-between items-center">

            <!-- Logo -->
            <div class="flex items-center space-x-2 cursor-pointer" @click="navigate('home')">
                <img :src="swifLogo" alt="Swif Study Abroad" class="h-8 md:h-9 w-auto" />
                <span class="text-gray-800 text-lg md:text-xl font-semibold">Swif Study Abroad</span>
            </div>

            <!-- Mobile Menu Button -->
            <button
                class="md:hidden w-12 h-12 flex flex-col justify-center items-center"
                @click="isMenuOpen = !isMenuOpen"
                aria-label="Toggle menu"
            >
                <span class="block w-6 h-0.5 bg-gray-800 mb-1 transition-transform duration-300"
                      :class="{ 'rotate-45 translate-y-1.5': isMenuOpen }"></span>
                <span class="block w-6 h-0.5 bg-gray-800 mb-1 transition-opacity duration-300"
                      :class="{ 'opacity-0': isMenuOpen }"></span>
                <span class="block w-6 h-0.5 bg-gray-800 transition-transform duration-300"
                      :class="{ '-rotate-45 -translate-y-1.5': isMenuOpen }"></span>
            </button>

            <!-- Navigation (Collapsible) -->
            <nav 
                class="w-full md:w-auto mt-4 md:mt-0 md:flex space-y-3 md:space-y-0 md:space-x-6 text-gray-700 font-medium"
                :class="{ 'hidden': !isMenuOpen, 'block': isMenuOpen }"
            >
                <router-link to="/" 
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'home' }">
                    Home
                </router-link>

                <router-link to="/about"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'about' }">
                    About Us
                </router-link>

                <router-link to="/services"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'services' }">
                    Immigration Services
                </router-link>

                <!-- <router-link to="/blog"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'blog' }">
                    Blog
                </router-link> -->

                <router-link to="/contact"
                    class="block py-2 hover:text-primary transition"
                    :class="{ 'text-primary font-bold': activePage === 'contact' }">
                    Contact Us
                </router-link>
            </nav>

            <!-- Action Button -->
            <div class="w-full md:w-auto mt-4 md:mt-0 flex justify-center md:justify-end">
                <router-link to="/scheduling"
                    class="w-full md:w-auto bg-primary text-white font-semibold py-3 px-4 rounded-lg shadow-lg hover:bg-primary/90 transition duration-300">
                    Book a Consultation
                </router-link>
            </div>
        </div>
    </header>
</template>
<style>
    /* Mobile-first responsive design */
    @media (min-width: 768px) {
        .container {
            flex-wrap: nowrap;
        }
        nav {
            display: flex !important;
        }
    }
    
    /* Custom styles */
    body { font-family: 'Inter', sans-serif;}

    .bg-primary { background-color: #D62828; }
    .text-primary { color: #D62828; }
    .border-primary { border-color: #D62828; }
    
    /* Ensure tap targets are at least 48px */
    a, button {
        min-height: 48px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

</style>
